import { ProUpgradeModalState } from '@dtx-company/inter-app/src/redux/slices/proUpgradeModalSlice'
import { RootState } from '@dtx-company/inter-app/src/redux/types'
import { useSelector } from 'react-redux'

export const useProUpgradeModalState = (): ProUpgradeModalState =>
  useSelector((state: RootState) => state.revenueReducer.proUpgradeModal)
